import { promisedRequest } from './helpers.js'

const PLEROMA_EXTENSION_FEDERATION_RESTRICTIONS_URL =
  '/api/v1/federation/restrictions/list'

export const fetchFederationRestrictions = () => {
  return promisedRequest({
    url: PLEROMA_EXTENSION_FEDERATION_RESTRICTIONS_URL,
  }).then(({ data }) => data)
}
